<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row class="pb-1">
          <b-col cols="8">
            <h4>Danh sách chủ đề bài viết</h4>
          </b-col>
          <b-col class="text-right" cols="4">
            <b-button class="btn-sm" variant="primary" @click="New()">
              <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
              Thêm mới chủ để
            </b-button>
          </b-col>
          <!-- Per Page -->
        </b-row>
        <b-row>
          <b-col cols="12">
            <vue-good-table
                :columns="options.fields"
                :isLoading.sync="isLoading"
                :line-numbers="true"
                :rows="items"
                :totalRows="totalRecords"
                mode="remote"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
            >
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                  <span>
                    <b-button
                        class="btn-icon"
                        size="sm"
                        variant="primary"
                        @click="Edit(props.row, props.row.id)"
                    >
                      <feather-icon icon="Edit2Icon"/>
                    </b-button>
                    <b-button
                        class="btn-icon"
                        size="sm"
                        style="margin-left: 6px"
                        variant="danger"
                        @click="DeleteItem(props.row, props.row.id)"
                    >
                      <feather-icon icon="TrashIcon"/>
                    </b-button>
                  </span>
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal id="modal-edit" :title="getTitle()" size="lg" @ok="handleOk">
      <b-row>
        <b-col cols="6">
          <b-form-group label="Level">
            <Select2
                v-model="currentItem.Level"
                :options="mockLv"
                placeholder="Chọn level... "
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Chủ đề cha">
            <Select2
                v-model="currentItem.ParentID"
                :disabled="currentItem.Level == 1"
                :options="itemsLv1"
                placeholder="Chọn chủ đề cha"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="Tên chủ đề">
            <b-form-input
                v-model="currentItem.Name"
                placeholder="Nhập tên chủ đề"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";

export default {
  name: "adminTopic",
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
  },
  methods: {
    getTitle() {
      if (this.editMode) {
        return "Cập nhật chủ đề ";
      } else {
        return "Thêm mới chủ đề ";
      }
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      console.log(this.serverParams);
      this.loadItems();
    },

    loadItems() {
      useJwt.get("/news/categories", this.serverParams).then((response) => {
        this.items = response.data.result;
        this.totalRecords = response.data.totalRecords;
        this.isLoading = false;
        // mapping groups item level 1
        const arrItemsLv1 = response.data.result.filter(
            (item) => item.Level == 1
        );

        this.itemsLv1 = arrItemsLv1.map((item) => {
          return {
            id: item.ID,
            text: item.Name,
          };
        });
      });
    },

    New() {
      this.currentItem = {};
      this.editMode = false;
      this.modal_title = "Thêm mới chủ đề ";
      this.$bvModal.show("modal-edit");
    },

    async Edit(item) {
      this.currentItem = item;
      console.log("tiem", this.currentItem);
      this.editMode = true;
      this.modal_title = "Cập nhật ";
      this.$bvModal.show("modal-edit");
    },

    async DeleteItem(item, index, button) {
      this.currentItem = item;
      const url = `news/categories/${item.ID}`;
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá dữ liệu chủ đề: " + item.Name,
          {title: "Please Confirm", size: "sm"}
      );
      if (resModal) {
        try {
          let res = await useJwt.delete(url);
          if (res.data.code == 200) {
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Xoá chủ đề thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          }
        } catch (error) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi xoá chủ đề ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },

    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      console.log("data input", this.currentItem);
      if (this.editMode) {
        const url = `/news/categories/${this.currentItem.ID}`;
        const params = {
          Name: this.currentItem.Name,
          ParentID: this.currentItem.ParentID,
          SortOrder: 1,
          Status: 1,
        };
        const res = await useJwt.put(url, params);
        if (res.data.code == 200) {
          this.loadItems();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Cập nhật thành công!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          this.$bvModal.hide("modal-edit");
        }
        return;
      }
      try {
        const res = await useJwt.post("news/categories", this.currentItem);
        if (res.data.code == 200) {
          this.loadItems();
          this.$bvModal.hide("modal-edit");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới chủ đề thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }
      } catch (error) {
        this.$bvModal.hide("modal-edit");
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới chủ đề ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }

      // close modal
      // this.$bvModal.hide('modal-edit')
    },
  },
  mounted() {
    this.loadItems();
  },
  data() {
    return {
      isLoading: false,
      totalRecords: 0,
      items: [],
      itemsLv1: [],
      mockLv: [
        {id: 1, text: "level 1"},
        {id: 2, text: "level 2"},
      ],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      currentItem: {
        SortOrder: 1,
        Status: 1,
        Level: "1",
      },
      editPhoneNote: "",
      options: {
        fields: [
          {
            field: "ID",
            filterOptions: {enabled: false, placeholder: ""},
            label: "ID",
            required: true,
            disabled: true,
          },
          {
            field: "Level",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Level",
            required: true,
            disabled: true,
          },
          {
            field: "Name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Name",
            required: true,
            disabled: true,
          },
          {
            field: "ParentID",
            filterOptions: {enabled: false, placeholder: ""},
            label: "ParentID",
            required: true,
            disabled: true,
          },

          {field: "action", label: "Actions", width: "120px"},
        ],
      },
    };
  },
};
</script>

<style>
</style>
